<div id="zoomModal" [style.display]="displayModal" class="zoom-modal" (click)="close($event)">
  <div>
  <span class="zoom-close" (click)="close($event)">×</span>
  <img [class]="imgContentClass" [src]="imageSrc" [alt]="imageCaption">
</div>
    <div id="zoom-caption">{{imageCaption}}</div>
  </div>